import { createContext, useContext } from "react";

const DashboardTitleStateContext = createContext();
const DashboardTitleStateProvider = DashboardTitleStateContext.Provider;
const useDashboardTitleStateContext = () => useContext(DashboardTitleStateContext);

export { DashboardTitleStateContext, DashboardTitleStateProvider, useDashboardTitleStateContext };
